<template>
  <div>
    <az-container>
      <az-form>
        <span class="primary--text font-weight-bold">Editais Abertos</span>

        <v-data-table :headers="colunas" :items="itens" :total-items="totalItens"
                      :pagination.sync="paginacaoInterna" :loading="false"
                      no-data-text="Não há licitações disponíveis" hide-actions
                      class="az-table-list table-todas-compras">
          <template slot="items" slot-scope="props">
            <tr>
              <td @click="$emit('acessar', props.item)">
                {{ props.item.dataAbertura | az-date(humanizarFormatoData(props.item.dataAbertura)) }}<br>
                <span v-if="props.item.dataAbertura">
                  {{ props.item.dataAbertura | az-date(humanizarFormatoHora(props.item.dataAbertura)) }}
                </span>
              </td>
              <td @click="$emit('acessar', props.item)">
                {{ props.item.numeroEdital }}
              </td>
              <td @click="$emit('acessar', props.item)">
                {{ props.item.numProcesso }}
                <br>
                <span v-if="props.item.quantidadeRepeticoes">
                  <strong> Repetição: {{props.item.quantidadeRepeticoes}} </strong>
                </span>
              </td>
              <td @click="$emit('acessar', props.item)">
                <expansao-texto :tamanho="125" :texto="props.item.objeto"/>
              </td>
              <td @click="$emit('acessar', props.item)">
                {{ props.item.siglaOrgao }}
              </td>
              <td @click="$emit('acessar', props.item)">
                {{ props.item.modalidade | azEnum(modalidadesLicitacao)}}
              </td>
              <td @click="$emit('acessar', props.item)">
                {{ props.item.modoDisputa | azEnum(modosDisputa)}}
              </td>
              <td @click="$emit('acessar', props.item)">
                {{ obterSituacao(props.item) }}
              </td>
              <td class="table-actions">
                <!--Fazer isso aparecer se quiser baixar ata  (só remover && false)-->
                <botao-download v-if="props.item.situacao === 'ENCERRADA' && false"
                                @download="$emit('baixarAta', props.item.id)"
                                :id="'botao-baixar-ata'+props.item.id"
                                class="mr-3 botao-menor"/>
                <v-tooltip top v-if="props.item.linkAcessoExterno">
                  <a @click="$emit('acessarLicitacaoSgc')" slot="activator" class="pr-1">
                    <i class="fas fa-external-link-square-alt" aria-hidden="true"/>
                    <span class="acao-mobile">Acessar</span>
                  </a>
                    Participar
                </v-tooltip>
                <v-tooltip top v-if="props.item.linkAcessoExterno">
                  <a slot="activator" @click="$emit('acessar', props.item)">
                    <v-icon class="blob laranja" color="orange" aria-hidden="true" style="font-size: 18px;">info</v-icon>
                  </a>
                  <span>Esta licitação foi criada no SGC, ao acessar você será direcionado para o sistema antigo.</span>
                </v-tooltip>
                <v-tooltip top v-else>
                  <a @click="$emit('acessar', props.item)" slot="activator">
                    <i class="fas fa-sign-in-alt" aria-hidden="true"/>
                    <span class="acao-mobile">Acessar</span>
                  </a>
                  Acessar
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
        <div class="az-pagination">
          <v-pagination v-model="paginacaoInterna.page" :length="paginas"/>
          <div class="az-select-pagination">
            <span>Linhas por página:</span>
            <v-select :items="linhasPorPagina" v-model="paginacaoInterna.rowsPerPage"/>
          </div>
        </div>
      </az-form>
    </az-container>
  </div>
</template>

<script>
import {modosDisputa, statusLicitacao, modalidadesLicitacao} from '@/core/constants'
import BotaoDownload from '../../../../components/BotaoDownload'
import moment from 'moment'

export default {
    name: 'TodasLicitacoesTabela',
    components: {BotaoDownload},
    props: ['itens', 'paginacao', 'paginas', 'totalItens'],
    data() {
        return {
            modosDisputa,
            statusLicitacao,
            modalidadesLicitacao,
            paginacaoInterna: this.paginacao,
            linhasPorPagina: [10, 25, 50],
            colunas: [
                {
                    value: 'dataAbertura',
                    text: 'Abertura',
                    align: 'left',
                    width: '40px',
                    sortable: false,
                    class: 'primary--text'
                },
                {
                    value: 'numeroEdital',
                    text: 'Nº Edital',
                    align: 'left',
                    width: '60px',
                    sortable: false,
                    class: 'primary--text'
                },
                {
                    value: 'numProcesso',
                    text: 'Nº Processo',
                    align: 'left',
                    width: '100px',
                    sortable: false,
                    class: 'primary--text'
                },
                {
                    value: 'objeto',
                    text: 'Objeto',
                    align: 'left',
                    width: '200px',
                    sortable: false,
                    class: 'primary--text'
                },
                {
                    value: 'orgao',
                    text: 'Órgão',
                    align: 'left',
                    width: '80px',
                    sortable: false,
                    class: 'primary--text'
                },
                {
                    value: 'modalidade',
                    text: 'Procedimento',
                    align: 'left',
                    width: '50px',
                    sortable: false,
                    class: 'primary--text'
                },
                {
                    value: 'modoDisputa',
                    text: 'Modo Disputa',
                    align: 'left',
                    width: '50px',
                    sortable: false,
                    class: 'primary--text'
                },
                {
                    value: 'status',
                    text: 'Situação',
                    align: 'left',
                    width: '50px',
                    sortable: false,
                    class: 'primary--text'
                },
                {
                    sortable: false,
                    text: 'Ações',
                    width: '20px',
                    align: 'center',
                    class: 'primary--text'
                }
            ],
        }
    },
    computed: {
        obterSituacao() {
            return (item) => {
                if (item && item.modalidade === 'CREDENCIAMENTO') {
                    return this.obterSituacaoCredenciamento(item)
                }
                const azEnum = this.$options.filters && this.$options.filters.azEnum ? this.$options.filters.azEnum : ((v) => v)
                return azEnum(item && item.status, this.statusLicitacao)
            }
        },
        obterSituacaoCredenciamento() {
            return (item) => {
                if (item) {
                    if (this.ehCredenciamentoAguardandoAbertura(item)) {
                        return 'Aguardando Abertura'
                    }
                    return 'Aberto'
                }
                return 'Em Elaboração'
            }
        },
        ehCredenciamentoAguardandoAbertura() {
            return (item) => {
                if (item) {
                    const dataAbertura = moment(item.dataAbertura)
                    const dataAtual = moment(new Date())
                    return dataAtual.isBefore(dataAbertura)
                }
                return false
            }
        },
    },
    watch: {
        paginacaoInterna: {
            handler(novoValor) {
                this.$emit('paginar', novoValor)
            },
            deep: true
        }
    }
}
</script>

<style scoped lang="stylus">
.az-container
    margin-top 10px
    margin-bottom 60px

.table-todas-compras
    border solid 2px rgba(169, 169, 169, 0.3)

    .acao-mobile
        display none

    td:hover
        cursor pointer !important

@media (max-width 720px)
  .table-todas-compras
    td:nth-of-type(1):before
      content "Abertura:"

    td:nth-of-type(2):before
      content "Nº Edital:"

    td:nth-of-type(2):before
      content "Nº Processo:"

    td:nth-of-type(3):before
      content "Objeto:"

    td:nth-of-type(5):before
      content "Órgão:"

    td:nth-of-type(4):before
      content "Procedimento:"

    td:nth-of-type(4):before
      content "Modo Disputa:"

    td:nth-of-type(6):before
      content "Situação:"

    td:nth-of-type(7):before
      display none

    .acao-mobile
      display inline-block
      margin-left 3px

@media (max-width 500px)
  .az-container
    margin-bottom 0
</style>
